import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as HazardTriangle } from "../../assets/svg/hazardTriangle.svg";
import { GRAY_700, WARNING_50, WARNING_200, WARNING_500, WARNING_600, WARNING_700 } from "../../constant/colors";
import { Routes } from "../../constant/routes";
import { fontWeights, sizes } from "../../constant/styles";
import { useGetSetting } from "../../hooks/getSetting";
import { formatPatientDisplayId } from "../../utils/formaters";

const { Text } = Typography;

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 45px;
  gap: 8px;
  padding: 8px 16px;
  margin: 0 15px 10px 15px;
  border-radius: 8px;
  border: 1px solid ${WARNING_200};
  background: ${WARNING_50};
`;

const AlertText = styled(Text)`
  color: ${GRAY_700};
  font-size: ${sizes.medium};
  line-height: 20px;
`;

const StyledHazardTriangle = styled(HazardTriangle)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  path {
    stroke: ${WARNING_500};
    stroke-width: 1.5;
  }
`;

const ViewRecordLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${WARNING_600};
  font-size: ${sizes.medium};
  font-weight: ${fontWeights.semibold};
  white-space: nowrap;

  &:hover,
  &:focus {
    color: ${WARNING_700};
  }
`;

const PatientMergedBanner = ({ mergedIntoPatient }) => {
  const { t } = useTranslation();
  const [prefix] = useGetSetting(["id_prefix"]);

  if (!mergedIntoPatient?.id) {
    return null;
  }

  const displayId = formatPatientDisplayId(prefix, mergedIntoPatient.id);

  return (
    <BannerContainer>
      <Space align="center">
        <StyledHazardTriangle />
        <AlertText id="patient_merged_banner_text">
          {t("patientTopSection.merge.merged_into_banner", { patientId: displayId })}
        </AlertText>
      </Space>
      <ViewRecordLink
        to={Routes.PATIENT_PATH({ patientId: mergedIntoPatient.id })}
        id="patient_merged_banner_view_record"
      >
        {t("patientTopSection.merge.view_record")}
        <ArrowRightOutlined />
      </ViewRecordLink>
    </BannerContainer>
  );
};

export default PatientMergedBanner;
